import React from "react";

interface Props {
  value: string;
  name: any;
  placeholder: string;
  type: any;
  inputMode?: React.HTMLAttributes<HTMLInputElement>["inputMode"];
  onChange: (e: any) => void;
  label: any;
  errors?: any;
  clickSubmit?: boolean;
  fullWidth?: boolean;
}
const InputController = (props: Props) => {
  return (
    <div className={`input-container-wrapper me-3 ${props.fullWidth ? "w-100" : ""}`}>
      {props.label !== null ? (
        <>
          <label htmlFor="">{props.label}</label>
        </>
      ) : null}
      <input
        type={props.type}
        inputMode={props.inputMode}
        value={props.value}
        name={props.name}
        className="input-control"
        placeholder={props.placeholder}
        onChange={props.onChange}
      />

      {props.errors && props.errors.error && props.clickSubmit ? (
        <div className="error-line">
          <span>{props.errors.message}</span>
        </div>
      ) : null}
    </div>
  );
};

export default InputController;
